export const TEST_IDS = {
  // Header
  headerLogo: "header-logo",
  headerBookBtn: "header-book-btn",
  
  // Hero
  heroSection: "hero-section",
  heroBookBtn: "hero-book-button",
  heroVideo: "hero-video",
  
  // Experience
  experienceSection: "experience-section",
  
  // Price
  priceSection: "price-section",
  
  // Locations
  locationsSection: "locations-section",
  locationCard: "location-card",
  
  // Booking
  bookingSection: "booking-section",
  bookingNameInput: "booking-name-input",
  bookingPhoneInput: "booking-phone-input",
  bookingEmailInput: "booking-email-input",
  bookingDateInput: "booking-date-input",
  bookingTimeSelect: "booking-time-select",
  bookingOccasionInput: "booking-occasion-input",
  bookingLocationSelect: "booking-location-select",
  bookingNextBtn: "booking-next-btn",
  bookingSubmitBtn: "submit-booking-button",
  
  // UPI
  upiQrCode: "upi-qr-code",
  copyUpiBtn: "copy-upi-button",
  upiTransactionInput: "upi-transaction-input",
  
  // FAQ
  faqSection: "faq-section",
  
  // Thank you
  thankYouPage: "thank-you-page",
  bookingReference: "booking-reference",
  bookingStatusBadge: "booking-status-badge",
  
  // Admin
  adminPanel: "admin-panel",
  adminLoginInput: "admin-login-input",
  adminLoginBtn: "admin-login-btn",
  adminBookingsTable: "admin-bookings-table",
  adminSearchInput: "admin-search-input",
  adminStatusFilter: "admin-status-filter",
  adminLocationFilter: "admin-location-filter",
};
